import {Component, OnInit, Input } from '@angular/core';
import { ToggleModel } from '../toggle.model';

@Component({
    selector: 'abw-toggle-result',
    templateUrl: './toggle-result.component.html',
    styleUrls: ['./toggle-result.component.scss']
})
export class ToggleResultComponent implements OnInit {
	@Input() model: ToggleModel;
    @Input() value: any;

    constructor(
    ) {
    }

    ngOnInit() {
    }
}